import { render, staticRenderFns } from "./item-reply-edit.vue?vue&type=template&id=f223f088&"
import script from "./item-reply-edit.vue?vue&type=script&lang=js&"
export * from "./item-reply-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports